import * as http from '../../../vue_shared/http'

interface BaseOptions {
  search_text?: string
  page_number?: number
}

type OptionType =
  | 'tags'
  | 'message_templates'
  | 'requesters'
  | 'staff'
  | 'departments'
  | 'closure_templates'

interface Option {
  id: number
  name: string
}

interface FetchOptions extends BaseOptions {
  type: OptionType
}

export function fetchRequestDataByType(
  options: FetchOptions
): Promise<Option[]> {
  const { type, ...params } = options
  switch (type) {
    case 'message_templates':
      return http.get<Option[]>(`/client/accounts/${type}/`, params)

    case 'departments':
      return http.get<Option[]>(`/client/departments/`, params)

    case 'closure_templates':
      return http.get<Option[]>(`/client/close_request_types/`, params)

    default:
      return http.get<Option[]>(`/client/requests/${type}/`, params)
  }
}
